/** @jsx jsx */
import { jsx } from '@emotion/core';

import { SafePureComponent } from '../../../../utils/SafePureComponent';
import * as styles from './index.styles';

export default class Slider extends SafePureComponent {
  getDefaultStar = () => (
    <svg
      width="17"
      height="17"
      viewBox="0 0 17 17"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M8.5 1L10.231 6.529H16L11.416 9.974L13.218 15.52L8.5 12.092L3.782 15.52L5.584 9.974L1 6.529H6.769L8.5 1Z"
        stroke="#393939"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );

  getFillStar = () => (
    <svg
      width="17"
      height="17"
      viewBox="0 0 17 17"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M8.5 1L10.231 6.529H16L11.416 9.974L13.218 15.52L8.5 12.092L3.782 15.52L5.584 9.974L1 6.529H6.769L8.5 1Z"
        fill="#008385"
        stroke="#008385"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );

  getStar = () => {
    // const rating = 3;
    // const maxStar = 5;

    const { maxStar, rating } = this.props;

    let returnArr = [];
    for (let index = 0; index < maxStar; index++) {
      if (index < rating) {
        returnArr.push(this.getFillStar());
      } else {
        returnArr.push(this.getDefaultStar());
      }
    }
    return returnArr;
  };

  safeRender() {
    // {/* <div css={styles.homepageSlide}> */}

    return this.getStar();
  }
}
